export default __webpack_public_path__ + "static/media/plushCare.b04fcb99.png";